module.exports = __webpack_public_path__ + "img/ranking-5.90789e32.svg";